import AiFocusAgentAPI from 'dashboard/api/aifocus/agent';
import { createStore } from './storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'AiFocusAgent',
  API: AiFocusAgentAPI,
  actions: mutationTypes => ({
    playground: async function playground(
      _,
      { agentId, messageContent, messageHistory, sessionId, files }
    ) {
      try {
        const response = await AiFocusAgentAPI.playground({
          agentId,
          messageContent,
          messageHistory,
          sessionId,
          files,
        });
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    sync: async function sync({ commit }, { id }) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { isUpdating: true });
        const response = await AiFocusAgentAPI.sync(id);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { isUpdating: false });
      }
    },
    syncAll: async function syncAll({ commit }) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { isFetching: true });
        const response = await AiFocusAgentAPI.syncAll();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { isFetching: false });
      }
    },
    getTools: async function getTools() {
      try {
        const response = await AiFocusAgentAPI.getTools();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    getModels: async function getModels() {
      try {
        const response = await AiFocusAgentAPI.getModels();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    getMcpServers: async function getMcpServers() {
      try {
        const response = await AiFocusAgentAPI.getMcpServers();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    getApiKeys: async function getApiKeys() {
      try {
        const response = await AiFocusAgentAPI.getApiKeys();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    getAgentTypes: async function getAgentTypes() {
      try {
        const response = await AiFocusAgentAPI.getAgentTypes();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
  }),
});
